import { render, staticRenderFns } from "./UserProfileMenu.vue?vue&type=template&id=0547162d&scoped=true&"
import script from "./UserProfileMenu.vue?vue&type=script&lang=js&"
export * from "./UserProfileMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileMenu.vue?vue&type=style&index=0&id=0547162d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0547162d",
  null
  
)

export default component.exports